import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { TextField, MenuItem } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { EnabledDisabled } from 'modules/Settings/constant';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginRight: theme.spacing(2),
      minWidth: theme.spacing(19)
    }
  })
);
type OptedInDropdownProps = {
  value?: EnabledDisabled;
  rowID: string;
};

const TextfieldInputLabel = (
  <FormattedMessage id="collectorSetting.userEnableLabel" />
);

const options = [
  {
    value: EnabledDisabled.enabled,
    label: <FormattedMessage id="collectorSetting.yes" />
  },
  {
    value: EnabledDisabled.disabled,
    label: <FormattedMessage id="collectorSetting.no" />
  }
];

export const OptedInDropdown: React.FC<OptedInDropdownProps> = ({
  value,
  rowID
}: OptedInDropdownProps) => {
  const classes = useStyles();
  const { control } = useFormContext();
  const dropDownName = useMemo(() => `${rowID}.optedIn`, [rowID]);

  return (
    <Controller
      render={({ field, ...props }) => (
        <TextField
          data-testid={`opted-in-drop-down-${rowID}`}
          label={TextfieldInputLabel}
          select
          size="small"
          className={classes.root}
          variant="outlined"
          {...field}
          {...props}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
      name={dropDownName}
      control={control}
      defaultValue={value || EnabledDisabled.enabled}
    />
  );
};
